import React from 'react';

import styles from './AudioPlaybackSelect.module.scss';

type AudioPlaybackSelectMenu = {
  // メニューの値
  value: number;
  // タイトル
  title: string;
};

type Props = {
  // デフォルト値
  defaultValue: number;
  // メニュー変更処理
  onChnage: (value: number) => void;
  // 表示するメニュー一覧
  menu: AudioPlaybackSelectMenu[];
};

const AudioPlaybackSelect = React.memo<Props>((props) => {
  // メニュー
  const optionMenus = props.menu.map((item) => (
    <option value={item.value}>{item.title}</option>
  ));

  return (
    <div className={styles['playback-speed']}>
      <select
        className={styles['playback-speed-select']}
        defaultValue={props.defaultValue}
        onChange={(e) => props.onChnage(parseFloat(e.target.value))}
      >
        {optionMenus}
      </select>
    </div>
  );
});

export default AudioPlaybackSelect;
